<template>
    <div>
        <el-dialog v-model="videoShow" title="Tips" width="500" :show-close="false">
            <template #header>
                <div class="header">试看视频</div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <div id="mui-player">
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import "mui-player/dist/mui-player.min.css";
import MuiPlayerDesktopPlugin from "mui-player-desktop-plugin";
import MuiPlayer from "mui-player";
export default {
    name: "GjkcH5VideoDialog",
    props: {
        selectedVideo: {}
    },
    watch: {
        videoShow(val) {
            if (val) {
                this.$nextTick(() => this.initPlayer())
            }
        }
    },
    data() {
        return {
            videoShow: false,
            plugins: [],
            mp: {},
            title: '',
            definitionCongig: [
                { functions: "蓝光1080P", selected: false, url: "11111" },
                { functions: "超清", selected: false, url: "22222" },
                { functions: "高清", selected: true, url: "33333" },
                { functions: "标清", selected: false, url: "44444" },
            ],
            videoInfo: {},
            selectedVideoInfo:{},
        };
    },

    mounted() {

    },

    methods: {
        closePopup() {
            this.videoShow = false
            this.mp && this.mp.destroy() // 显式销毁实例
        },
        // 监听播放事件，是否第一次播放，第一次播放添加定时器记录学习时间(每十秒上传一次)
        handlerPlay() {

        },
        on_hd() {
            this.mp.toggleControls();

            //清晰度切换
            this.mp.reloadUrl("");

            this.mp.showToast("清晰度切换成功！");
        },
        initPlayer() {
            // if (this.mp) this.mp.destroy()
            this.mp = new MuiPlayer({
                container: "#mui-player",
                title: this.title,
                src: this.selectedVideo,
                // width:762,
                height: 450, // 高度
                autoFit: false, // 是否自适应高度
                objectFit: "cover", // cover全覆盖容器
                videoAttribute: [
                    { attrKey: "webkit-playsinline", attrValue: "" },
                    { attrKey: "playsinline", attrValue: "" },
                    { attrKey: "x5-playsinline", attrValue: "" },
                    { attrKey: "t7-video-player-type", attrValue: "inline" },
                    { attrKey: "x5-video-player-type", attrValue: "h5-page" },
                    { attrKey: "x-webkit-airplay", attrValue: "allow" },
                    { attrKey: "controlslist", attrValue: "nodownload" },
                ],
                plugins: [
                    typeof MuiPlayerDesktopPlugin == "function"
                        ? new MuiPlayerDesktopPlugin({
                            customSetting: [
                                {
                                    functions: "清晰度",
                                    model: "select",
                                    show: true,
                                    zIndex: 0,
                                    childConfig: this.definitionCongig,
                                    onToggle: (e) => {
                                        console.log(e);
                                        this.definitionCongig.forEach((item) => {
                                            item.selected = false;
                                            if (item.functions == e.functions) {
                                                item.selected = true;
                                                this.mp.showToast("清晰度切换成功！");
                                            }
                                        });
                                    },
                                },
                            ],
                        })
                        : {},
                ],
                custom: {
                    rightSidebar: [
                        {
                            slot: "HD", // 对应定义的 slot 值
                            width: "200px", // 侧栏宽度，string | number
                        },
                    ],
                },
            })
            this.mp.on("ready", () => {
                this.videoInfo = this.mp.video();
                // 将视频封面替换成课程设置的封面图
                this.videoInfo.poster = this.selectedVideoInfo?.chapterResource?.previewVideoCoverImg;
            })
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 800px;
    min-height: 270px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    //   text-align: center;
    //   font-weight: bold;
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

.dialog_content {
    padding: 20px;

    #mui-player {
        border-radius: 10px;
    }
}
</style>